module.exports = __webpack_public_path__ + "img/OANDA_Onboarding_HeaderAnim_ES.f461ba3f.png";